import * as Yup from 'yup';
import { Shape } from '../yup_types';

export enum VALIDATION_FORM_FIELD {
	URL = 'url'
}

export type ValidationType = {
	[VALIDATION_FORM_FIELD.URL]: string,
}

export type ValidationReturnType = {
	url: string,
}

export const getValidationDetailsSchema = (): Yup.SchemaOf<ValidationType> => Yup.object<Shape<ValidationType>>().shape({
	[VALIDATION_FORM_FIELD.URL]: Yup.string()
		.url('Please enter a valid HTTPS URL or IP address (e.g. https://www.flex-charge.com) and try again.')
		.required('URL is required'),
});

export const initialValidationValues: ValidationType = {
	[VALIDATION_FORM_FIELD.URL]: '',
};

export const getFormattedValidationFormFields = (formikValues): ValidationReturnType => ({
	url: formikValues?.[VALIDATION_FORM_FIELD.URL]
});
